var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.32 520.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f2e4;}.cls-2{fill:#10585e;}.cls-3,.cls-9{fill:#fff;}.cls-4{fill:#1e1a1a;}.cls-5{fill:#f8804f;}.cls-6{fill:#faa77a;}.cls-7{fill:#332b2b;}.cls-8{fill:#1b9bab;}.cls-9{stroke:#f5f2e4;stroke-miterlimit:10;stroke-width:8px;}.cls-10,.cls-11{fill:#03a4af;}.cls-11{font-size:30px;font-family:Quicksand-Bold, Quicksand;font-weight:700;}.cls-12{letter-spacing:-0.01em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:-0.01em;}.cls-15{letter-spacing:0em;}.cls-16{fill:#610;}.cls-17{fill:#ddd;}.cls-18{fill:#440e06;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leon_Philosophiert",
    "data-name": "Leon Philosophiert"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Torso_hello_Kopie",
    "data-name": "Torso_hello Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-Shirt",
    className: "cls-1",
    d: "M171.16,174.82c16.45,12.52,37.1,9.73,59.78-4.22,17.76,25.3,21,143.58,29.25,236.4-46.21-3.9-63.83-7.16-114-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.22,229.61c1.16,53-4.57,164.92-4.57,164.92,3.87,6.14-53.56,10.62-53.53,1.28.12-33.93,2.34-65.39,7.4-92.69,0,0,6.1-78.62,5.59-115.83l-2.42-15.65c-20.29,3.11-15.91-12.36-17.26-17.46l13.31-2.48a14.52,14.52,0,0,1,13.21,4c.3,2.11.83,4,5.64,4.45,1.5.85,3.08,2.23,2.7,3.91l26.87,5,37.73,14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.14,156.24,164,152.35c-1.49-.09-3.24,2.17-4.45,3l-6.93,1c-.94.13-3.4,6.32-4.23,5.87-9.92-5.38-110,3.28-104.14,10.76,0,0,41.26,24.55,59.24,24.55l35.42,73.56-4,113.26,39.94,4.47L170,278.71a153.9,153.9,0,0,1,.28-17.84l6.08-81.34C182.76,173.13,181.91,160.41,181.14,156.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239,264.51h0a2.06,2.06,0,0,1-2.06-2.06c4.43-18.06,3.54-39,0-61.35A2.07,2.07,0,0,1,239,199h0a2.07,2.07,0,0,1,2.06,2.07c2.88,22.05,3.81,43,0,61.35A2.06,2.06,0,0,1,239,264.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.05,261.69h0a2.07,2.07,0,0,0,2.07-2.06c-4.44-18.06,1.7-37.68,5.23-60a2.07,2.07,0,0,0-2.06-2.07h0a2.07,2.07,0,0,0-2.06,2.07c-2.88,22-9,41.71-5.24,60A2.06,2.06,0,0,0,159.05,261.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "139.48 385.41 37.29 381.99 181.44 469.15 248.2 469.15 354.38 389.88 139.48 385.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "225.15 435.46 197.68 454.42 215.66 465.02 234.36 457.78 225.15 435.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "195.53 478.87 230.76 488.57 240.83 463.76 197.68 454.42 195.53 478.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.2,516.75c15.67-7.23,37.27-24.76,49.71-36.4l-37.3-10.25-32.29,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.32,481.82c-1.38.34,22.67-9.08,25.12-10.14-66.29,12.42-31.94,50.4-10.21,48.79,11.5-.85,36.3-19,50.71-36.38-3,2.51-41.39,31.29-40.67,30.23,3.47-5.16.95-13.74-1.52-20.75A19.52,19.52,0,0,0,131.32,481.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M370.6,211.41c10.32,10.33,27.45,21.83,26.91,32.08s-16,21.68-21.71,23.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M400.48,336.91c38.12-22.06,5-90.64-6.28-102-6.78-6.77-16.9-11.65-23.6,16.49-1.33,5.56,15.22,51.19,14.49,58.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.57,
    y: 193.96,
    width: 348.51,
    height: 202.68,
    rx: 6.02,
    transform: "matrix(1, -0.09, 0.09, 1, -26.54, 20.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M240.86,420.53l139-84.31a19.31,19.31,0,0,1,12.87-1.37L397.5,336a24.11,24.11,0,0,1,18.16,19.51l.11.66a32.38,32.38,0,0,1-16.52,33.74c-32,30.44-92.63,58.31-158.21,85.73l-19.14-41,8.18-10.47,6.94,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.05,416.26,37.29,382c-10.88-2.53-15.43-2-19.43-.05l-4.35,2.13A24.11,24.11,0,0,0,0,407.08l0,.67a32.36,32.36,0,0,0,23.48,29.32c2.94,1,19,6.19,25.41,7.46,29,5.71,99.66,29.68,146.87,37.17L206.39,442l-27.55-6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.66,488.3c-6.67-2.86,6.32-33.19,13-30.33,0,0,22.72,4.41,29.91,5.9,14.33,3,19.38,5.45,36,11.76,12.4,1.26-17.69,49.91-21.69,39.91-14-5.18-14-5.18-30.75-11.94C237.32,501.25,216.66,488.3,216.66,488.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.23,472.42c2.9.27-28.74-7.25-32.4-10.91,15.48,2.06,27.82,7,37.52,10.4,6.23,2.17,14.52,16.66,11.35,27.45s-16.24,35.12-70.9-1.29c6.12,2.35,39.38,17.55,36.77,15.86C266.06,505.14,267.11,480.48,287.23,472.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.46,494.2c-2.45-1.05,1.24-19.49,9.44-22,3.25,1.39-3.11,7.25-4.72,11S252,496.19,248.46,494.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.44,498.22c-2.45-1.05,1.24-19.5,9.44-22,3.25,1.39-3.11,7.26-4.72,11S260.94,500.21,257.44,498.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.69,487.06c-2.46-1.05,1.24-19.49,9.43-22,3.26,1.4-3.11,7.26-4.72,11S235.18,489.05,231.69,487.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.26,490.66c-2.25-1,1.93-19.69,9.67-22.58,3,1.28-.59,5.52-2.24,9.37S243.44,492.53,240.26,490.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101,307.56c-2.33-9.23-9.58-16-17.66-17.61a21,21,0,0,0-21.17,7.49A20.23,20.23,0,0,0,60.05,319a20.91,20.91,0,0,0,19.2,11.39l.4,0a3,3,0,0,1,3.09,2.89c.17,4.31.18,8.64.25,13l-3.86-1.18c4.23-4.18,8.43-8.37,13-12.31-3,5.2-6.3,10.13-9.58,15.08a2.08,2.08,0,0,1-3.79-.77l-.07-.4c-.76-4.26-1.59-8.51-2.26-12.78l3.49,2.87a26.66,26.66,0,0,1-15.74-2.44,27.28,27.28,0,0,1-15-27.27,30,30,0,0,1,2.1-8,30.44,30.44,0,0,1,4.33-7,28,28,0,0,1,13.74-8.61,27.13,27.13,0,0,1,15.82.79,25.43,25.43,0,0,1,12,9.46A22.79,22.79,0,0,1,101,307.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M89.4,308.27c2.33,9.23,9.58,16,17.66,17.61a21,21,0,0,0,21.17-7.5,20.21,20.21,0,0,0,2.1-21.58,20.85,20.85,0,0,0-19.2-11.39h-.4a3,3,0,0,1-3.08-2.88c-.17-4.32-.18-8.65-.25-13l3.86,1.17c-4.23,4.18-8.44,8.37-13,12.31,3-5.19,6.29-10.13,9.58-15.08a2.08,2.08,0,0,1,2.89-.58,2,2,0,0,1,.89,1.36l.08.4c.76,4.25,1.59,8.5,2.25,12.77l-3.48-2.87a26.63,26.63,0,0,1,15.73,2.45A27.44,27.44,0,0,1,138,292.7a27.74,27.74,0,0,1,3.28,16.07,30.12,30.12,0,0,1-2.11,8,30.83,30.83,0,0,1-4.32,7,27.93,27.93,0,0,1-13.74,8.6,27.13,27.13,0,0,1-15.82-.78,25.49,25.49,0,0,1-12-9.46A22.83,22.83,0,0,1,89.4,308.27Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "matrix(1, -0.1, 0.1, 1, 152.11, 297.27)"
  }, "S", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 17.91,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 36.03,
    y: 0
  }, "zia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 76.32,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 84.12,
    y: 0
  }, "coaching "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "M\xFCnchen")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.87,482.17c1.72,2.41,7.66,10.92,9.66,16.37.53,1.45,2.05,1.31,2.21-.23.46-4.21-5-14-5.76-15.23a1.56,1.56,0,0,0-.17-.25c-4.93-6-5.92-4.67-6.3-2.24A2.27,2.27,0,0,0,154.87,482.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.29,479s7,13.77,9.93,16.33c4.06,0,1.08-8.45-3.28-13.4S161.53,475,163.29,479Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180,489.08l-11.59-14.29,5.48,1.6s1.64,2.07,4.36,5.16S183.14,492.2,180,489.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.84,477.48c1.46,2.53,5.11,8.55,6.29,8.6s2.22-1.48,1.09-3.21-3.19-4.3-3.19-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.69,183.15c-2.5,12.9,5.17,21.73,12.77,27.74,9.15,7.24,102.33,18.06,120.32,15.18,3.91-20.23,8.33-22.15-.24-26.08-5.29-2.43-34.3-4.65-61.16-12.68-16.6-4.95-28.71-18.69-32-17.83C37.48,172.33,11.19,170.25,8.69,183.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.78,199.7c2.43-1.48,4.28-6,12.32-15,2.9-4.66,2.61-16.66,4.05-17.28.8-.35,5.06.76,6,1.75,1.79,2,2.13,5.53,2.51,7.31,2,9.29-7.2,12.13-1.23,15.33,3,1.61,13.94,2.6,15.37,2.95,2.54.62,6,2.81,3.32,9.17,2.28,1,1.87,6-.42,8.92,2.65,1.76-.24,8.77-1.65,9.77,2.3,2.16-1.37,6.91-4.51,7.76-6.65,1.79-33.67-3-35.82-5.3C130.23,225.05,131.22,199.7,140.78,199.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.78,199.7c-7.27,7.26,1.89,23.38-.08,25.35C130.23,225.05,131.22,199.7,140.78,199.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.65,326.77c9.57-9.57,25.05-21.14,33.44-16.79s16.67,24.29,16.26,28.65-17.58,7.65-17.58,7.65c-3.65,0-8.24-1.33-7.07-4.13-10.18,5.21-14.61,2.34-14.61-1.39-5.37.77-7-2.13-5.83-6.38C348.1,335.39,347.94,329.8,351.65,326.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.33,330c3.79-3.79,13.87-9.52,16.79-10.57C378.54,317.89,364.18,323.7,363.33,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M367.14,337.49c2.52-2.68,14.49-12.43,19.12-12.28C381,330,369.66,336.44,367.14,337.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.49,340.29c4.54-3,9.44-6.37,11.42-6.76C386.57,338.15,378.49,340.29,378.49,340.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Kopf_Kopie_Kopie",
    "data-name": "Kopf Kopie Kopie"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Throat_Kopie",
    "data-name": "Throat Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.93,141.3v19.93a9.91,9.91,0,0,0,9,9.86l6.75.55c-6.79,6.8-36.59,17-54.3,7.89,0-3.3,3.94-7.73,3.94-11.62V145.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.93,140.3v20.93a9.91,9.91,0,0,0,1,4.41c-14.93,1.56-32.65-6-35.64-8.74V144.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    className: "cls-6",
    d: "M152.09,35h90.15L237,112.31a26,26,0,0,1-11.35,20.38l-23,17a12.44,12.44,0,0,1-13.12.56l-22.14-13.6A26,26,0,0,1,154.09,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-16",
    d: "M149.45,27.8l-7.06,1.63-2.3,17.86a23.11,23.11,0,0,0,.62,17.37l3.61,8.06,9.42,10.33-.92-21.77a14.37,14.37,0,0,1,2.55-8l3.36-4.83c2.19-1.8,46.93,9.79,72.13-.16.9,3.24,5,8.57,7.77,11.34a4.64,4.64,0,0,1,1.24,3.6L238,80.92l9.82-10.85,3.73-18.62c.75-12.72-7.41-36.27-14.58-35.82,2.1-2.73,10.86-4.73,12.08-11-48.24-9.11-81-5.58-99.38,16.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    className: "cls-5",
    d: "M184.62,105.22c6,5.45,12.39,5.53,18.95-1.17v2.23a5.92,5.92,0,0,1-2.66,5.11C194,115.87,185.58,111.74,184.62,105.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ear_L_Kopie",
    "data-name": "Ear_L Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.9,80.2c-10.45-14.7-17.36-13.8-17.36,2.17,0,13.24,12.51,24,16.55,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M153.24,99.36c-3.49-3.48-5.11-7.44-4.42-9.3s3-1.16,3-4.65-2.56-8.14-3.72-6.51,2.32,4.88,1.62,6.28-4.18,2.79-3.95,5.11S149.17,99.83,153.24,99.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ear_R_Kopie",
    "data-name": "Ear_R Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.1,79.31C245.57,65.39,250,66,252.86,83.54c0,13.24-12.88,23.37-16.19,23.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.32,99.36c3.49-3.48,5.11-7.44,4.42-9.3s-3-1.16-3-4.65,2.56-8.14,3.72-6.51-2.32,4.88-1.62,6.28S245,88,244.76,90.29,241.39,99.83,237.32,99.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mund_smile_Kopie",
    "data-name": "Mund_smile Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.09,120.89c16.93,0,17.12-2,19-3.89,1.17-1.13-.14-1.93-1.47-2.73,1.93.08,3.54.55,3.35,3.16-6.09,6.09-12.35,5.89-21.7,5.89-3.67,0-17.46,0-21.51-2.92-.68-.67-1.36-1.61.65-3.13-.8,1.52.41,1.92,1.53,2.73C179.91,121.23,197.09,120.89,197.09,120.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.7,126.84c4,2.27,11.36,1.6,14.32.66,2.17,2.17-2.63,4-6.51,4S186.07,129.25,188.7,126.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes_front_Kopie",
    "data-name": "Eyes_front Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M226.43,80.91c0,3.1-4.78,6.48-10.67,6.48s-10.67-1.23-10.67-4.34,4.78-6.91,10.67-6.91S226.43,77.8,226.43,80.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M221.44,80.65c0,3.44-2.8,5.44-6.25,5.44s-6.26-2.37-6.26-5.44C208.93,74.12,221.44,74.12,221.44,80.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,80.07c0,2.1-1.71,3.32-3.82,3.32a3.57,3.57,0,0,1-3.82-3.32C211.37,75.16,219,75.76,219,80.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 219.99,
    cy: 81.92,
    r: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,83.05a4.71,4.71,0,0,1,.92-3.29,9.33,9.33,0,0,1,2.52-2.45,12.88,12.88,0,0,1,6.65-2.14,19.93,19.93,0,0,1,6.81.93,9.19,9.19,0,0,1,3.1,1.68,4.78,4.78,0,0,1,1.11,1.41,3.05,3.05,0,0,1,.23,1.72,3.33,3.33,0,0,0-.7-1.42,4.47,4.47,0,0,0-1.21-.91,10.49,10.49,0,0,0-2.94-1,25.16,25.16,0,0,0-3.14-.38,26,26,0,0,0-3.18-.06,13.11,13.11,0,0,0-3,.43,15.28,15.28,0,0,0-2.9,1.06,10.88,10.88,0,0,0-2.57,1.74A5.27,5.27,0,0,0,205.09,83.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M162.44,80.91c0,3.1,4.78,6.48,10.67,6.48s10.67-1.23,10.67-4.34-4.77-6.91-10.67-6.91S162.44,77.8,162.44,80.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.43,80.65c0,3.44,2.8,5.44,6.25,5.44s6.26-2.37,6.26-5.44C179.94,74.12,167.43,74.12,167.43,80.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,80.07c0,2.1,1.71,3.32,3.82,3.32a3.57,3.57,0,0,0,3.82-3.32C177.5,75.16,169.86,75.76,169.86,80.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 177.5,
    cy: 81.92,
    r: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,83.05a4.75,4.75,0,0,0-.91-3.29,9.51,9.51,0,0,0-2.53-2.45,12.88,12.88,0,0,0-6.65-2.14,19.93,19.93,0,0,0-6.81.93,9.05,9.05,0,0,0-3.09,1.68,4.66,4.66,0,0,0-1.12,1.41,3.05,3.05,0,0,0-.23,1.72,3.33,3.33,0,0,1,.7-1.42,4.47,4.47,0,0,1,1.21-.91,10.49,10.49,0,0,1,2.94-1,25.16,25.16,0,0,1,3.14-.38,26,26,0,0,1,3.18-.06,13.11,13.11,0,0,1,3,.43,15.28,15.28,0,0,1,2.9,1.06,10.88,10.88,0,0,1,2.57,1.74A5.27,5.27,0,0,1,183.78,83.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrows_Kopie",
    "data-name": "Eyebrows Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M204.73,73.16l1.2-6.07L218.22,66c6.92-.07,11.79,6.45,11.79,6.45C218.35,70.31,219.28,70.51,204.73,73.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M182.71,73.16l-1.2-6.07L169.22,66c-6.92-.07-11.79,6.45-11.79,6.45C169.09,70.31,168.16,70.51,182.71,73.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143,69.77c.73-.73-7.78-9.78-2.91-22.48,1.22-3.17,2.48-.29,5.7,7.78,6.67-7.35,5.84-17.88,7.45-22.9,6.13,6.65,5.49,16.26,5.49,16.26-6,6-5.37,18.33-5.49,29.53C147.29,72,143,69.77,143,69.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M158.73,48.43c0-9.34,7.3-17.16,39.57-24.62a26.75,26.75,0,0,1-4.21,8.81c1.35-1.34,38.28-6.56,38.28,11,7.82-7.82,12.93-9.5,16.37-10.64,1.27,2.07,3.31,15.94,2.82,18.5-1.4,7-2.62,13.85-3.7,18.46-2.48-1.09-4.91.7-9.76,9.4.59-4.8,1.48-13.32,1.77-16.1,0-3.62-10.47-12.91-9-14.94C214.43,55,187.17,52.23,158.73,48.43Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/image4.893adf36750571e0ac3982acabfc5b82.svg";
export { ForwardRef as ReactComponent };